// // src/store/slices/activityLogSlice.js
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import activityLogApi from 'api/activityLogApi';

// export const fetchActivityLogs = createAsyncThunk(
//   'activityLog/fetchAll',
//   async (filters = {}, { rejectWithValue }) => {
//     try {
//       const data = await activityLogApi.getAll(filters);
//       return data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response?.data?.detail || 'Failed to fetch activity logs'
//       );
//     }
//   }
// );

// const activityLogSlice = createSlice({
//   name: 'activityLog',
//   initialState: {
//     logs: [],
//     pagination: {
//       count: 0,
//       page: 1,
//       page_size: 10,
//       total_pages: 1,
//     },
//     isLoading: false,
//     error: null,
//   },
//   reducers: {
//     clearActivityLogs: (state) => {
//       state.logs = [];
//       state.pagination = { ...state.pagination, count: 0 };
//       state.error = null;
//     },
//     clearError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchActivityLogs.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(fetchActivityLogs.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.logs = action.payload.data || [];
//         state.pagination = {
//           count: action.payload.count || 0,
//           page: action.payload.page || 1,
//           page_size: action.payload.page_size || 10,
//           total_pages: action.payload.total_pages || 1,
//           next: action.payload.next || null,
//           previous: action.payload.previous || null,
//         };
//       })
//       .addCase(fetchActivityLogs.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearActivityLogs, clearError } = activityLogSlice.actions;
// export default activityLogSlice.reducer;


// src/store/slices/activityLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import activityLogApi from 'api/activityLogApi';

export const fetchActivityLogs = createAsyncThunk(
  'activityLog/fetchAll',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const data = await activityLogApi.getAll(filters);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail || 'Failed to fetch activity logs'
      );
    }
  }
);

const activityLogSlice = createSlice({
  name: 'activityLog',
  initialState: {
    logs: [],
    pagination: {
      count: 0,
      current_page: 1,
      page_size: 10,
      total_pages: 1,
      next: null,
      previous: null,
    },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearActivityLogs: (state) => {
      state.logs = [];
      state.pagination = { ...state.pagination, count: 0 };
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityLogs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchActivityLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data || [];
        // Fixed: Access pagination from the correct nested structure
        state.pagination = action.payload.pagination || {
          count: 0,
          current_page: 1,
          page_size: 10,
          total_pages: 1,
          next: null,
          previous: null,
        };
      })
      .addCase(fetchActivityLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearActivityLogs, clearError } = activityLogSlice.actions;
export default activityLogSlice.reducer;